import React from "react";

const SchemesAll = React.createContext();

export default SchemesAll;
